import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { RevealWrapper } from "./styles/RevealStyles";

// Fades its content up the first time it scrolls into view. Browsers without
// IntersectionObserver just show it; reduced motion is handled in the styles.
const Reveal = ({ children, delay, stretch, className }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(
    typeof IntersectionObserver === "undefined"
  );

  useEffect(() => {
    if (visible) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px" }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [visible]);

  return (
    <RevealWrapper
      ref={ref}
      delay={delay}
      stretch={stretch}
      className={`${className} ${visible ? "is-visible" : ""}`}
    >
      {children}
    </RevealWrapper>
  );
};

Reveal.propTypes = {
  delay: PropTypes.number,
  stretch: PropTypes.bool,
  className: PropTypes.string,
};

Reveal.defaultProps = {
  delay: 0,
  stretch: false,
  className: "",
};

export default Reveal;
